import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateLectureItem as updateLectureItemApi } from "../../../../services/dashboard/apiLecture";
import toast from "react-hot-toast";

function useUpdateLectureItem() {
  const queryClient = useQueryClient();

  const {
    mutate: updateLectureItem,
    isPending: isUpdating,
    error,
  } = useMutation({
    mutationFn: updateLectureItemApi,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lectureItemsDashboard"] });
      toast.success("تم تعديل المحتوي بنجاح");
    },
    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { updateLectureItem, isUpdating, error };
}

export default useUpdateLectureItem;
